import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

import SpecialText from '../fragments/SpecialText';
import SmartLink from '../fragments/SmartLink';

export default function SiteOverview({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const introRevealRef = useReveal({ once: true });
    const mediaRevealRef = useReveal({ once: true });
    const textRevealRef = useReveal({ once: true });

    const text_maximum_width = (block.text_maximum_width ? block.text_maximum_width + 'em' : '40em');

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--site-overview`}>
            <div className={`l-grid`}>
                <div className={`l-grid__col l-bottom-section-space c-transition-in`} ref={introRevealRef}>
                    {block.large_text &&
                        <h1 className="c-site-overview__large-text c-heading" style={{ maxWidth: text_maximum_width }}>
                            <SpecialText text={block.large_text} />
                        </h1>
                    }
                    {block.button_text && block.button_url &&
                        <div className="c-links c-site-overview__links l-small-top-space">
                            <SmartLink
                                link={block.button_url} 
                                className="c-links__link c-links__link--button"
                            >
                                <svg viewBox="0 0 22 10"><polygon points="16.93 .91 16.25 1.64 19.33 4.5 0 4.5 0 5.5 19.33 5.5 16.25 8.36 16.93 9.09 21.33 5 16.93 .91" /></svg>
                                {block.button_text}
                            </SmartLink>
                        </div>
                    }
                </div>
                <div className={`l-grid__col l-grid__col--m-8-12 l-grid__col--m-push-4-12 c-transition-in`} ref={mediaRevealRef}>
                    {block.img_src &&
                        <Image 
                            src={block.img_src || []} 
                            width={block.img_width} 
                            height={block.img_height} 
                            alt={block.img_alt || ''} 
                        />
                    }
                </div>
                <div className={`l-grid__col l-grid__col--m-8-12 l-grid__col--m-push-4-12 l-grid__col--l-6-12 l-grid__col--xl-4-12 c-transition-in`} ref={textRevealRef}>
                    <div className="scope-text l-small-top-space" dangerouslySetInnerHTML={{ __html: block.text || '' }} />
                    {block.links && block.links.length > 0 &&
                        <div className="c-links l-small-top-space">
                            {block.links.map((link, index) => (
                                <SmartLink
                                    link={link.url} 
                                    key={index} 
                                    className="c-links__link"
                                >
                                    {link.text}
                                </SmartLink>
                            ))}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}